import type { ClientProfileDataResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const formatProfileFullName = (
	data?: ClientProfileDataResponseDTO | null,
): string =>
	[data?.firstName, data?.lastName]
		.map((part) => part?.trim())
		.filter(Boolean)
		.join(" ");
